







































































































import Vue from "vue";
import Menu from "./settings-menu/Menu.vue";
import Notifications from "./notifications/Notifications.vue";
import NotificationsMenu from "./notifications/NotificationsMenu.vue";
import PassivePopup from "@/components/PassivePopup.vue";
import { ref, onMounted, computed } from "@vue/composition-api";
import Tab from "./Tab.vue";
import { UseModal } from "../modal";
import PlansModal from "@/components/modals/plans-modal/PlansModal.vue";
import { SharedState } from "@/common/state/index";
import { AppAnalytics } from "@/analytics";
import UseCasesPopup from "./use-cases/UseCasesPopup.vue";
import TrialBtn from "./TrialBtn.vue";
import Logo from "./Logo.vue";
import ReleaseNotesModalVue from "@/components/modals/release-notes/ReleaseNotesModal.vue";
import {
  get_allowed_apps_from_restrictions,
  Restriction,
} from "@/common/models/admin-restrictions.model";
import { show_dd_configure_menu } from "@/components/root/navbar/tabs-menus/configuration-menu/configuration.menu";
import { EventBus } from "@/eventbus";
import SupportNavbarBtnVue from "./support/SupportNavbarBtn.vue";

export default Vue.extend({
  components: {
    PassivePopup,
    Tab,
    Menu,
    Logo,
    Notifications,
    NotificationsMenu,
    UseCasesPopup,
    TrialBtn,
    SupportNavbarBtnVue,
  },
  setup(_, { root: { $route, $router } }) {
    const { loggedUser, paymentEdition } = SharedState;

    const allowed_apps = computed(() => {
      const user = SharedState.loggedUser.value;
      // @ts-ignore
      const restrictions: Restriction[] = user.restrictions;
      return get_allowed_apps_from_restrictions(restrictions);
    });

    const show_config_menu = ref(false);

    const on_config_menu = async (event: MouseEvent) => {
      await show_dd_configure_menu(event);
    };

    const featureExport = computed(() => paymentEdition.value.export);

    const showMenu = ref(false);
    const tab = ref("Mapping");
    const routeName = ref("");
    const setTabByName = (name: string) => {
      switch (name) {
        case "Investigation":
        case "Investigation-drilldown":
          tab.value = "Investigation";
          break;
        case "DataSourceManagement":
        case "InformationCustomization":
        case "InMotionCustomization":
        case "MIP":
        case "TrustManagement":
          tab.value = "Configuration";
          break;
        case "Overview":
          tab.value = "Overview";
          break;
        case "Playbooks":
          tab.value = "Playbooks";
          break;
        case "Reports":
          tab.value = "Reports";
          break;
        default:
          tab.value = "";
          break;
      }
    };

    onMounted(() => {
      routeName.value = $route.name || "";
      setTabByName($route.name || "");
      $router.afterEach((to) => {
        setTabByName(to.name || "");
        routeName.value = to.name || "";
      });
    });

    const set_tab_as_playbooks = () => {
      if (SharedState.is_biz_user.value) {
        SharedState.restrictions.show_restrictions_modal("role", "Playbooks");
        return;
      }
      set_route("Playbooks");
    };

    const set_tab_as_reports = () => {
      if (
        SharedState.restrictions.is_restricted_app("reports") &&
        SharedState.restrictions.is_restricted_app("event_justification")
      ) {
        SharedState.restrictions.show_restrictions_modal(
          "app",
          "Reports & Event Justification"
        );
        return;
      }
      set_route("Reports");
    };

    const set_route = (route_name: string) => {
      if (route_name != $router.currentRoute.name) {
        $router.replace({ name: route_name });
      } else {
        if (route_name == "Overview") {
          // show the overview menu
          EventBus.emit("show_overview_menu");
        }
      }
    };

    const onMenuItemClicked = (item: string) => {
      showMenu.value = false;
      AppAnalytics.report({
        component: "Settings",
        eventName: "Settings",
      });
      switch (item) {
        case "changePlan":
          AppAnalytics.report({
            component: "Settings",
            eventName: "Change_plan[Area:Settings, Action:Open]",
          });
          UseModal().show(PlansModal);
          break;

        case "customize":
          $router.push({ name: "Customization" });
          break;

        case "accounts":
          $router.push({ name: "Accounts" });
          break;

        case "unprotected-accounts":
          $router.push({ name: "UnprotectedAccounts" });
          break;

        case "ghost-accounts":
          $router.push({ name: "GhostAccounts" });
          break;

        case "admins":
          $router.push({ name: "Admins" });
          break;

        case "integrations":
          $router.push({ name: "Integrations" });
          break;

        case "release-notes":
          UseModal().show(ReleaseNotesModalVue);
          break;

        case "support":
          on_support_clicked();

          break;
        case "logout":
        default:
          UseModal()
            .showSimple({
              title: "Logout",
              desc: "Logout of Cognni?",
              submitBtnText: "Logout",
              cancelBtnText: "Stay",
            })
            .then((res) => {
              if (res.type == "success") {
                AppAnalytics.report({
                  component: "Settings",
                  eventName: "Settings_Log-out_apply",
                });
                SharedState.logout({ explicit: true });
              }
            });
          break;
      }
      AppAnalytics.report({
        component: "Settings",
        eventName: `Settings_clicked[Button:${item}]`,
      });
    };

    const goHome = () => {
      $router.push({ name: "default" });
      AppAnalytics.report({
        component: "General",
        eventName: "Cognni logo",
      });
    };

    /* notifications */
    const showNotifications = ref(false);
    /* use cases */
    const showUseCases = ref(false);
    const show_menu_count = ref(0);

    const on_support_clicked = () => {
      window.open("https://docs.cognni.ai/en/", "_blank");
    };

    const toggle_show_menu = () => {
      show_menu_count.value++;
      showMenu.value = !showMenu.value;
      if (show_menu_count.value >= 4) {
        SharedState.features.value = {
          ...SharedState.features.value,
          conversation: {
            ...SharedState.features.value["conversation"],
            enabled: true,
          },
        };
      }
    };
    return {
      featureExport,
      toggle_show_menu,
      set_tab_as_playbooks,
      set_tab_as_reports,
      set_route,
      showMenu,
      tab,
      is_biz_user: SharedState.is_biz_user,
      is_mip_enabled: SharedState.is_mip_enabled,
      show_config_menu,
      on_config_menu,
      onMenuItemClicked,
      loggedUser,
      goHome,
      showNotifications,
      on_support_clicked,
      showUseCases,
      has_solutions: SharedState.has_solutions,
      is_playbooks_enabled: computed(
        () =>
          SharedState.features.value.it_scripts &&
          SharedState.features.value.it_scripts?.enabled
      ),
      has_reports_feature: computed(
        () =>
          SharedState.features.value.reports &&
          SharedState.features.value.reports?.enabled
      ),
    };
  },
});
